const brandUrlMapping = {
  thinggaard: process.env.REACT_APP_BRAND_ID ?? 2,
  localhost: process.env.REACT_APP_BRAND_ID ?? 2,
  "thinggaard-dk": process.env.REACT_APP_BRAND_ID ?? 2,
  "ucpa-dk": 5,
  ucpa: 5,
  vhservice: 18,
};

const brandMapping = {
  2: "thinggaard",
  7: "thinggaard",
  5: "ucpa",
  18: "vhservice",
};

const baseDomain = window.location.hostname.split(".")[0];

export const BRAND_ID = brandUrlMapping[baseDomain];
export const BRAND = brandMapping[BRAND_ID];

console.log({ BRAND, BRAND_ID, env: process.env.BRAND_ID });
const buildApiUrl = () => {
  const domain = buildDomain();
  const protocol = process.env.NODE_ENV === "development" ? "http" : "https";

  return `${protocol}://${domain}`;
};

const buildDomain = () => {
  if (process.env.NODE_ENV === "development")
    return process.env.WORDPRESS_DOMAIN ?? "thinggaard-dk.local";

  if (BRAND === "ucpa") return "ucpa.dk";
  if (BRAND === "vhservice") return "vhservice.dk";

  return "thinggaard.dk";
};

export const PAX_DEFAULT = BRAND_ID === 7 || BRAND_ID === 5 ? 1 : 2;
export const PAX_DEFAULT_STRING =
  BRAND_ID === 7 || BRAND_ID === 5 ? "30" : "30,30";
export const API_URL = buildApiUrl();
export const API_ENDPOINT_STRING =
  BRAND_ID === 5 ? "ucpa" : BRAND_ID === 18 ? "thinggaard" : "thinggaard";
export const API_ENDPOINT_DOMAIN = buildDomain();
